import { render, staticRenderFns } from "./p-video.vue?vue&type=template&id=103e51fa&scoped=true&"
import script from "./p-video.vue?vue&type=script&lang=js&"
export * from "./p-video.vue?vue&type=script&lang=js&"
import style0 from "./p-video.vue?vue&type=style&index=0&id=103e51fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103e51fa",
  null
  
)

export default component.exports